export default {
    // 园区建设进度
    parkConstructionProgress: {
        total: 0.77,
        mall: 0.45,
        building: 0.72,
        road: 0.87,
        assorted: 0.56
    },
    // 建设详情
    constructionDetailInfo: {
        'A': [{
            name: 'A01',
            area: '232 ㎡',
            process: 0.7
        },{
            name: 'A02',
            area: '132 ㎡',
            process: 0.95
        },{
            name: 'A03',
            area: '302 ㎡',
            process: 0.9
        },{
            name: 'A04',
            area: '152 ㎡',
            process: 0.75
        },{
            name: 'A05',
            area: '289 ㎡',
            process: 0.6
        },{
            name: 'A06',
            area: '124 ㎡',
            process: 0.78
        }],
        'B': [{
            name: 'B01',
            area: '345 ㎡',
            process: 0.89
        },{
            name: 'B02',
            area: '435 ㎡',
            process: 0.78
        },{
            name: 'B03',
            area: '234 ㎡',
            process: 0.56
        },{
            name: 'B04',
            area: '124 ㎡',
            process: 0.84
        },{
            name: 'B05',
            area: '167 ㎡',
            process: 0.86
        },{
            name: 'B06',
            area: '234 ㎡',
            process: 0.56
        },{
            name: 'B07',
            area: '312 ㎡',
            process: 0.48
        },{
            name: 'B08',
            area: '256 ㎡',
            process: 0.6
        }],
        'C': [{
            name: 'C01',
            area: '254 ㎡',
            process: 0.97
        },{
            name: 'C02',
            area: '176 ㎡',
            process: 0.80
        },{
            name: 'C03',
            area: '185 ㎡',
            process: 0.57
        },{
            name: 'C04',
            area: '321 ㎡',
            process: 0.76
        },{
            name: 'C05',
            area: '254 ㎡',
            process: 0.46
        }],
    },
    // 施工项目
    constructionProject: {
        month: {
            time: '（2021-08-01 -- 2021-08-08）',
            xData: ['08-01', '08-02', '08-03', '08-04', '08-05', '08-06', '08-07', '08-08'],
            yData: [21, 32, 54, 23, 43, 43, 32, 50]
        },
        day: {
            time: '（2021-08-08）',
            xData: ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
            yData: [4, 13, 14, 15, 18, 13, 8, 3]
        }
    },
    // 项目概况
    projectCount: {
        '普通项目': 36,
        '一般项目': 55,
        '重点项目': 12,
        '在建项目': 34,
        '已建项目': 45,
        '待建项目': 27
    },
    // 管道修建进度
    pipeProgresValue: [0.5, 0.67, 0.78, 0.61, 0.84],
    // 资源的使用
    resourceUse: {
        '混凝土': 45,
        '水泥': 50,
        '沙土': 30,
        '钢筋': 87,
    }
};